/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmTrxCountInfo } from './EvmTrxCountInfo';

export type KiteBlockDetailInfo = {
    BNO: string;
    BHA: string;
    STS: KiteBlockDetailInfo.STS;
    TCNTINFO: EvmTrxCountInfo;
    AG: string;
    UT: number;
    PT: string;
    GU: string;
    GUP: string;
    GL: string;
    BFPG: string;
    BFPGG: string;
    BF: string;
    PRHA: string;
    DF: string;
    TDF: string;
    SI: string;
    RT: string;
    TR: string;
    ST: string;
    S3U: string;
    NON: string;
};

export namespace KiteBlockDetailInfo {

    export enum STS {
        FINALIZED = 'FINALIZED',
        UNFILALIZED = 'UNFILALIZED',
    }


}

